import api from 'utils/api';
import { GET_TEAMS } from './constants';

export const addTeams = (body) => async (dispatch) => {
  try {
    const { data } = await api.post('/teams/add', body, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  } catch (error) {
    console.log('error', error);
  }
};

export const getAllTeams = () => async (dispatch) => {
  try {
    const { data } = await api.get('/teams/get');
    dispatch({
      type: GET_TEAMS,
      payload: data
    });
  } catch (error) {
    console.log('error');
    throw error;
  }
};

export const deleteTeams = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/teams/delete?id=${id}`);
    dispatch(getAllTeams());
  } catch (error) {
    console.log('error');
  }
};

export const editTeams = (id, body) => async (dispatch) => {
  try {
    const { data } = await api.put(`/teams/edit?id=${id}`, body, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    dispatch(getAllTeams());
  } catch (error) {
    console.log('error');
  }
};
